// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=4224b4e6-b1a4-45e8-8f80-865a6362eb01";
};